import { render, staticRenderFns } from "./Negotiation.vue?vue&type=template&id=683003f9&"
import script from "./Negotiation.vue?vue&type=script&lang=js&"
export * from "./Negotiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports